import { useEffect, useState } from 'react';

const useIsTouchDevice = () => {
  const [isTouchDevice, setIsTouchDevice] = useState<boolean>();

  const handleIsTouchDevice = (): void => {
    setIsTouchDevice('ontouchstart' in window || navigator.maxTouchPoints > 0);
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: Intentional Missing Dependencies
  useEffect(() => {
    handleIsTouchDevice();

    window.addEventListener('resize', handleIsTouchDevice);

    return () => window.removeEventListener('resize', handleIsTouchDevice);
  }, []);

  return isTouchDevice;
};

export default useIsTouchDevice;
